export default "__VITE_ASSET__DQCE3MAL__"